import { ListBase as List } from '@telus-uds/components-base';
export default List;